import moment from 'moment';

export const CLOUDINARY_PREFIX = 'https://res.cloudinary.com/fftech/video';

export const formatDate = (iso, by) => {
  if (!iso) return '—';
  const m = moment(iso);
  if (!m.isValid()) return '—';
  const date = m.format('MMM D, YYYY');
  if (by && by.includes('@')) return `${date} · ${by}`;
  return date;
};

export const isCloudinaryVideoUrl = (url) =>
  typeof url === 'string' && url.trim().startsWith(CLOUDINARY_PREFIX);

export const firstGraphQLError = (err) =>
  (err && err.errors && err.errors[0]) || err || {};
